import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
  makeStyles,
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  CardHeader
} from "@material-ui/core";
import UserContext from "../../UserContext";
import UserApiClient from "../../api/UserApiClient";
import { getAaiToken, removeAaiToken } from "../../utilities/tokenUtilities";
import HelpEmailLink from "../shared/common/HelpEmailLink";
import AuthorizationProblemEmailLink from "../shared/common/AuthorizationProblemEmailLink";

export default function LoginPage() {
  const classes = useStyles();
  const { user, loginUser } = useContext(UserContext);
  const history = useHistory();
  const [aaiToken, setAaiToken] = useState(getAaiToken());
  const maintenance = false;

  useEffect(() => {
    if (maintenance) {
      if (aaiToken) {
        removeAaiToken();
        setAaiToken(null as any);
      }
      return;
    }

    if (user.isAuthenticated) {
      history.replace("/");
    } else if (aaiToken) {
      const apiClient = new UserApiClient();
      apiClient
        .authorize(aaiToken)
        .then(function(response) {
          loginUser(response);
          history.replace("/");
        })
        .finally(function() {
          removeAaiToken();
        });
    }
  }, []);

  const handleLoginClick = () => {
    const loginUrl = process.env.REACT_APP_AAI_LOGIN_URL || "";
    window.location.replace(loginUrl);
  };

  return aaiToken && !maintenance ? (
    <></>
  ) : (
    <Container maxWidth="xl" className={classes.container}>
      <Box mx="auto" width="50%">
        <Card>
          <CardHeader title="Dobrodošli!" />
          <CardContent>
            {maintenance && (
              <Box
                mb={2}
                p={2}
                borderRadius={4}
                style={{
                  background: "#fff3cd",
                  border: "1px solid #ffeeba",
                  color: "#856404"
                }}
                role="alert"
                aria-live="assertive"
              >
                <strong style={{ display: "block", marginBottom: 4 }}>
                  Obavijest
                </strong>
                Sustav zbog nadogradnji trenutno nije dostupan. O ponovnom radu
                sustava bit ćete pravovremeno obaviješteni.
              </Box>
            )}

            <Typography gutterBottom>
              eTUR aplikacija je namijenjena za sufinanciranje troškova
              prijevoza, prehrane i posebnih nastavnih sredstava i pomagala za
              djecu s teškoćama u razvoju u osnovnim i srednjim školama.
            </Typography>
            <Button
              disabled={maintenance}
              variant="contained"
              color="primary"
              className={classes.loginButton}
              onClick={handleLoginClick}
            >
              Prijavi se
            </Button>
          </CardContent>
        </Card>
        <div className={classes.helpEmailDiv}>
          <HelpEmailLink />
          <br />
          <AuthorizationProblemEmailLink />
        </div>
      </Box>
    </Container>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: "#044c92",
    height: "100vh",
    paddingTop: "200px"
  },
  loginButton: {
    marginTop: "10px"
  },
  helpEmailDiv: {
    paddingTop: theme.spacing(3)
  }
}));
